import { type FC } from 'react';
import { AdUnit, type AdUnitProps } from './AdUnit.tsx';

import dibsCss from 'dibs-css';
import classNames from 'classnames';

export const BillboardBannerAd: FC<AdUnitProps> = ({
    adId,
    elementId,
    width = 320,
    height = 82,
    lazyLoad = false,
    sizes,
    heightHold,
    widthHold,
    className,
    shouldCollapseOnNoFill = true,
    onAbsentAd,
    testName,
    testVariant,
}) => {
    return (
        <AdUnit
            adId={adId}
            elementId={elementId}
            width={width}
            height={height}
            lazyLoad={lazyLoad}
            sizes={sizes}
            heightHold={heightHold}
            widthHold={widthHold}
            className={classNames(
                dibsCss.flex,
                dibsCss.itemsCenter,
                dibsCss.justifyCenter,
                className
            )}
            shouldCollapseOnNoFill={shouldCollapseOnNoFill}
            onAbsentAd={onAbsentAd}
            dataTn="billboard-banner-ad"
            testName={testName}
            testVariant={testVariant}
        />
    );
};
